export const buildLineChartOptionsProp = () => {
  return ({
    stacked: false,
    plugins: {
      tooltip: {
        intersect: false,
        mode: 'index',
      }
    },
    scales: {
      y: {
        display: true,
        position: 'left',
        suggestedMax: 100,
        suggestedMin: 0,
        type: 'linear',
        ticks: {
          callback: (value, _index, _values) => {
            return value + '%'
          }
        }
      },
      y1: {
        display: true,
        position: 'right',
        type: 'linear',
      }
    }
  })
}
